<p-blockUI [blocked]="loading" >
    <p-progressSpinner [style]="{width: '70px', height: '70px', display: 'block', 'margin-left':'auto', 'margin-right':'auto', 'margin-top':'250px'}" strokeWidth="8" fill="#EEEEEE" animationDuration="1.5s"></p-progressSpinner>
</p-blockUI>

<div class="p-grid" style="margin:15px;">
    <div class="p-col-12">
        <div class="p-grid">
            <div class="p-col-3">
                <p-calendar class="ui-fluid"   [(ngModel)]="dateDebut" [readonlyInput]="true" dateFormat="dd/mm/yy" [showIcon]="true" [appendTo]="'body'"></p-calendar>
            </div>
            <div class="p-col-3">
                <p-calendar class="ui-fluid"   [(ngModel)]="dateFin" [readonlyInput]="true" dateFormat="dd/mm/yy" [showIcon]="true" [appendTo]="'body'"></p-calendar>
            </div>
            <div class="p-col-2">
                <button  pButton type="button"  label="Récupérer" (click)="recupererLogs()" ></button>
            </div>
        </div>
    </div>

    <div class="p-col-12">
        <p-panel header="LISTE LOG">
            <p-table #dt [rowHover]="true" [rowsPerPageOptions]="[10,25,50]" styleClass="ui-table-customers" [columns]="logCols" [value]="listeLogs" [paginator]="true" [rows]="10" [showCurrentPageReport]="true" currentPageReportTemplate="Ligne {first} à {last} sur {totalRecords} lignes">
                <ng-template pTemplate="caption">
                    
                </ng-template>
    
                <ng-template pTemplate="header">
                    <tr>
                        <th *ngFor="let col of logCols" style="{{ColumnsWidth(col.field)}}"  [pSortableColumn]="col.field" [class]="(col.field === 'numPointAccueil') ? 'set-min' : ''">
                            {{col.header}}
                            <p-sortIcon [field]="col.field"></p-sortIcon>
                        </th>
    
                    </tr>
    
                </ng-template>
    
                <ng-template pTemplate="body" let-moderation let-columns="columns">
                    <tr>
                        <td *ngFor="let col of columns">
                                <span [class]="(col.field === 'etat' && moderation[col.field] !== '') ? ((moderation['idEtat'] === 3) ? 'customer-badge status-renewal' : 'customer-badge status-new' ) : ''">
                                    {{moderation[col.field]}}
                                </span>
                        </td>
                    </tr>
                </ng-template>
    
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="4" style="text-align:center; height: 50px;" >Pas de donnée à afficher.</td>
                    </tr>
                </ng-template>
            </p-table>
        </p-panel>
    </div>
</div>